import { useNuxtApp } from '#app'

export default defineNuxtRouteMiddleware(() => {
    useNuxtApp().$bus.$emit('hideModalImmediately')
})
